'use client';

import React from 'react';
import { VStack } from '@skin-seoul/design-system';
import RankingItem from './components/RankingItem';
import SectionContainer from '../../components/SectionContainer';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import { useParams } from 'next/navigation';
const ProductRankingsSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      rank
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  if (!rank || rank.length === 0) {
    return null;
  }
  return <SectionContainer headerTitle="Product Rankings" data-sentry-element="SectionContainer" data-sentry-component="ProductRankingsSection" data-sentry-source-file="ProductRankingsSection.tsx">
      <VStack gap={2} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="ProductRankingsSection.tsx">
        {rank?.map((ranking, index) => <RankingItem key={index} rank={ranking.rankInTerm} category={ranking.name} slug={ranking.slug} taxonomy={ranking.taxonomy} />)}
      </VStack>
    </SectionContainer>;
};
export default ProductRankingsSection;